(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-header"]) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!menu.matches('.sc-header__search, .sc-header__mobile-menu') || !menu.open) return;
    menu.closest('.sc-header').querySelectorAll('details[open]').forEach((other) => {
      if (other !== menu) other.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sc-header details[open]').forEach((menu) => {
      menu.open = false;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sc-header details[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-quote"] && !Shopify.designMode) return;
  try {
    
  const scQuoteCategory = new URLSearchParams(window.location.search).get('category');
  if (['Patches', 'Hats', 'Apparel', 'Tumblers', 'Other'].includes(scQuoteCategory)) {
    document.querySelectorAll('[data-sc-quote-category]').forEach((field) => {
      field.value = scQuoteCategory;
    });
  }
  const scQuoteHatParams = new URLSearchParams(window.location.search);
  const scQuoteHatDetails = [['Brand', 'hat_brand'], ['Model', 'hat_model'], ['Color', 'hat_color'], ['Interchangeable rope', 'interchangeable_rope'], ['Rope color', 'rope_color']]
    .map(([label, key]) => {
      const value = scQuoteHatParams.get(key);
      return value ? `${label}: ${value.slice(0, 200)}` : '';
    }).filter(Boolean);
  if (scQuoteHatDetails.length) {
    document.querySelectorAll('.sc-quote textarea[name="contact[body]"]').forEach((field) => {
      if (!field.value.trim()) field.value = `Custom hat request\n${scQuoteHatDetails.join('\n')}\n\nProject details: `;
    });
  }
  if (scQuoteCategory === 'Apparel') {
    document.querySelectorAll('.sc-quote').forEach((section) => {
      const details = [['brand', 'apparel_brand'], ['model', 'apparel_model'], ['color', 'apparel_color'], ['size', 'apparel_size']]
        .map(([label, key]) => {
          const value = scQuoteHatParams.get(key);
          return value ? `${section.dataset[label + 'Label']}: ${value.slice(0, 200)}` : '';
        }).filter(Boolean);
      const catalogDetails = scQuoteHatParams.get('apparel_details');
      const notes = section.querySelector('textarea[name="contact[body]"]');
      if (notes && !notes.value.trim() && (details.length || catalogDetails)) {
        notes.value = `${section.dataset.apparelRequest}\n${catalogDetails ? catalogDetails.slice(0, 8000) : details.join('\n')}\n\n${section.dataset.projectDetails}`;
      }
      const quantity = scQuoteHatParams.get('apparel_quantity');
      const quantityField = section.querySelector('input[name="contact[Estimated quantity]"]');
      if (quantityField && !quantityField.value && /^\d{1,7}$/.test(quantity || '') && Number(quantity) >= 1) quantityField.value = quantity;
    });
  }
  document.querySelectorAll('.sc-quote').forEach((section) => {
    const category = section.querySelector('[data-sc-quote-category]');
    const frontChest = section.querySelector('[data-sc-quote-front-chest]');
    const largeBack = section.querySelector('[data-sc-quote-large-back]');
    const notes = section.querySelector('textarea[name="contact[body]"]');
    if (!category || !frontChest || !largeBack) return;
    const validChoice = (value) => ['Yes', 'No'].includes(value) ? value : null;
    const readPlacement = (useUrl) => {
      let saved = {};
      try {saved = JSON.parse(sessionStorage.getItem('sc-apparel-placement') || '{}') || {};} catch {}
      frontChest.value = (useUrl && validChoice(scQuoteHatParams.get('apparel_front_chest_logo'))) || validChoice(saved.frontChestLogo) || 'No';
      largeBack.value = (useUrl && validChoice(scQuoteHatParams.get('apparel_large_back_logo'))) || validChoice(saved.largeBackLogo) || 'No';
    };
    const persistPlacement = () => {
      if (category.value !== 'Apparel') return;
      try {sessionStorage.setItem('sc-apparel-placement', JSON.stringify({frontChestLogo: frontChest.value, largeBackLogo: largeBack.value}));} catch {}
    };
    const escapePattern = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const choices = [...new Set(['Yes', 'No', section.dataset.yesLabel, section.dataset.noLabel])].map(escapePattern).join('|');
    const generatedSummary = new RegExp(`(^|\\n)(${escapePattern(section.dataset.apparelRequest)}\\r?\\n)${escapePattern(section.dataset.frontChestLabel)}: (?:${choices})\\r?\\n${escapePattern(section.dataset.largeBackLabel)}: (?:${choices})(?=\\r?\\n|$)`);
    const updateSummary = () => {
      if (!notes || category.value !== 'Apparel') return;
      const frontValue = frontChest.value === 'Yes' ? section.dataset.yesLabel : section.dataset.noLabel;
      const backValue = largeBack.value === 'Yes' ? section.dataset.yesLabel : section.dataset.noLabel;
      notes.value = notes.value.replace(generatedSummary, (match, boundary, heading) => `${boundary}${heading}${section.dataset.frontChestLabel}: ${frontValue}\n${section.dataset.largeBackLabel}: ${backValue}`);
    };
    const syncCategory = () => {
      const enabled = category.value === 'Apparel';
      section.querySelectorAll('[data-sc-quote-apparel-placement]').forEach((field) => {field.hidden = !enabled;});
      frontChest.disabled = !enabled;
      largeBack.disabled = !enabled;
      if (enabled) {persistPlacement();updateSummary();}
    };
    readPlacement(scQuoteCategory === 'Apparel');
    syncCategory();
    category.addEventListener('change', syncCategory);
    [frontChest, largeBack].forEach((field) => field.addEventListener('change', () => {persistPlacement();updateSummary();}));
    section.querySelector('form')?.addEventListener('submit', syncCategory);
    window.addEventListener('pageshow', () => {
      if (!section.isConnected) return;
      readPlacement(false);
      syncCategory();
    });
  });
  const scQuoteSuccess = document.querySelector('[data-sc-quote-success]');
  const scQuoteErrors = document.querySelector('[data-sc-quote-errors]');
  if (scQuoteSuccess) scQuoteSuccess.focus();
  else if (scQuoteErrors) scQuoteErrors.focus();

  } catch(e) { console.error(e); }
})();
})();
